import React, { ChangeEvent } from "react";
import { isNil } from "ramda";
import { Box, Button, Tooltip } from "@mui/material";
import { Data } from "../../../store/cert/types";
import { FormikProps, useFormikContext } from "formik";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
import ArrowUpward from "@mui/icons-material/ArrowUpward";

interface CertExportUploadBtns {
  isCertNew?: boolean;
  certificate?: Data;
  value: string;
}

const CLIENT = "CLIENT";

const CertExportUploadBtns = (props: CertExportUploadBtns) => {
  const { value, isCertNew, certificate } = props;
  const { setFieldValue } = useFormikContext<FormikProps<Data>>();

  const handleCSRLoad = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const fileReader = new FileReader();
      fileReader.readAsText(event.target.files[0]);
      fileReader.onload = (e) => {
        setFieldValue("attributes.CSR", e.target?.result);
      };
    }
  };

  const exportAction = (certData: Data) => {
    const { attributes } = certData;
    if (!isNil(attributes.X509)) {
      const contents = attributes.X509 as string;
      const element = document.createElement("a");
      const file = new Blob([contents], { type: "text/plain" });
      element.href = URL.createObjectURL(file);
      element.download = `${attributes.SerialNumber}.crt`;
      document.body.appendChild(element); // Required for this to work in FireFox
      element.click();
    }
    if (!isNil(attributes.CAX509Chain)) {
      const chainContents = attributes.CAX509Chain as string;
      const chainElement = document.createElement("a");
      const chainFile = new Blob([chainContents], { type: "text/plain" });
      chainElement.href = URL.createObjectURL(chainFile);
      chainElement.download = `${attributes.CASerialNumber}.crt`;
      document.body.appendChild(chainElement); // Required for this to work in FireFox
      chainElement.click();
    }
  };

  return (
    <Box ml={2}>
      {isCertNew ? (
        value === CLIENT && (
          <Box>
            <input
              accept="text/*"
              style={{ display: "none" }}
              id="contained-button-file"
              type="file"
              onChange={handleCSRLoad}
            />
            <label htmlFor="contained-button-file">
              <Button
                variant="outlined"
                color="primary"
                component="span"
                size="small"
                startIcon={<ArrowUpward />}
                onClick={(e: React.MouseEvent<HTMLElement>) =>
                  e.stopPropagation()
                }
              >
                Load CSR File
              </Button>
            </label>
          </Box>
        )
      ) : (
        <Tooltip title="Download related certificates" arrow>
          <Button
            type="button"
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<ArrowDownward />}
            onClick={() => exportAction(certificate as Data)}
          >
            Export
          </Button>
        </Tooltip>
      )}
    </Box>
  );
};

export default CertExportUploadBtns;
